module.exports = __webpack_public_path__ + "img/brain.e693e4ee.png";